// Global Variables

// APP Variables
export const APP_TITLE = 'Kirsten Kwan | Web Developer';
export const APP_AUTHOR = 'Kirsten Kwan';
export const APP_URL = 'https://kirstenkwan.ca'
export const URL_PREFIX = 'https://'
export const URL_SUFFIX = '.kirstenkwan.ca'